import { formatDistanceToNowStrict } from 'date-fns/formatDistanceToNowStrict';
import { useEffect, useState } from 'react';

interface LastRefreshedProps {
  lastRefreshed: Date;
  paused: boolean;
}

export function LastRefreshed({ lastRefreshed, paused }: LastRefreshedProps) {
  const [lastRefreshedAgo, setLastRefreshedAgo] = useState(
    `last synced ${formatDistanceToNowStrict(lastRefreshed, { addSuffix: true })}${paused ? ' (paused)' : ''}`
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setLastRefreshedAgo(
        `last synced ${formatDistanceToNowStrict(lastRefreshed, { addSuffix: true })}${paused ? ' (paused)' : ''}`
      );
    }, 1000);

    return () => clearInterval(timer);
  }, [lastRefreshed, paused]);

  return (
    <span className="text-sm font-normal font-mono text-gray-300 justify-self-end">
      {lastRefreshedAgo}
    </span>
  );
}
